import Typekey from './Typekey';

export default class PermissionType extends Typekey {
  static readonly viewPost = new PermissionType('viewPost', 'View Post', '');

  static readonly editPost = new PermissionType('editPost', 'Edit Post', '');

  static readonly deletePost = new PermissionType('deletePost', 'Delete Post', '');

  static readonly createPost = new PermissionType('createPost', 'Create Post', '');

  static readonly approvePost = new PermissionType('approvePost', 'Approve Post', '');

  static readonly viewOwnPost = new PermissionType('viewOwnPost', 'ViewOwn Post', '');

  static readonly editOwnPost = new PermissionType('editOwnPost', 'Edit OwnPost', '');

  static readonly deleteOwnPost = new PermissionType('deleteOwnPost', 'Delete OwnPost', '');

  static readonly createOwnPost = new PermissionType('createOwnPost', 'Create OwnPost', '');

  static readonly blockPost = new PermissionType('blockPost', 'Block Post', '');

  static readonly viewUser = new PermissionType('viewUser', 'View User', '');

  static readonly editUser = new PermissionType('editUser', 'Edit User', '');

  static readonly deleteUser = new PermissionType('deleteUser', 'Delete User', '');

  static readonly createUser = new PermissionType('createUser', 'Create User', '');

  static readonly blockUser = new PermissionType('blockUser', 'Block User', '');

  static readonly revokeUser = new PermissionType('revokeUser', 'Revoke User', '');

  static readonly createCampAdd = new PermissionType('createCampAdd', 'Create Campaign Add', '');

  static readonly canViewAdminPage = new PermissionType('canViewAdminPage', 'Can View Admin page', '');

  static readonly canViewHomePage = new PermissionType('canViewHomePage', 'Can View Home page', '');

  static readonly canViewOrgPost = new PermissionType('canViewOrgPost', 'Can View Org Post', '');

  static readonly canViewOrgsetings = new PermissionType('canViewOrgPost', 'Can View Org Post', '');

  static readonly canViewUserSettings = new PermissionType('canViewOrgPost', 'Can View Org Post', '');

  static readonly canViewOrganization = new PermissionType('canViewOrganization', 'Can View Organization', '');

  static readonly canViewRoles = new PermissionType('canViewRoles', 'Can View Roles', '');

  static readonly canCreateOrganization = new PermissionType('canCreateOrganization', 'Can Create Organization', '');

  static readonly canViewSettings = new PermissionType('canViewSettings', 'Can View Settings', '');

  static readonly showAdminTab = new PermissionType('showAdminTab', 'Show Admin Tab', '');

  static allPermissions() {
    return [
      PermissionType.createPost,
      PermissionType.showAdminTab,
      PermissionType.createUser,
      PermissionType.deleteOwnPost,
      PermissionType.deletePost,
      PermissionType.deleteUser,
      PermissionType.editOwnPost,
      PermissionType.editPost,
      PermissionType.editUser,
      PermissionType.revokeUser,
      PermissionType.viewOwnPost,
      PermissionType.viewPost,
      PermissionType.viewUser,
      PermissionType.approvePost,
      PermissionType.blockPost,
      PermissionType.blockUser,
      PermissionType.createOwnPost,
      PermissionType.createCampAdd,
      PermissionType.canViewAdminPage,
      PermissionType.canViewHomePage,
      PermissionType.canViewOrgPost,
      PermissionType.canViewOrgsetings,
      PermissionType.canViewUserSettings,
      PermissionType.canViewOrganization,
      PermissionType.canViewRoles,
      PermissionType.canCreateOrganization,
      PermissionType.canViewSettings,
    ];
  }
}
